var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40413 15.5896C4.48122 15.6669 4.57279 15.7281 4.67361 15.77C4.77442 15.8118 4.88249 15.8333 4.99163 15.8333C5.10077 15.8333 5.20884 15.8118 5.30965 15.77C5.41046 15.7281 5.50203 15.6669 5.57913 15.5896L14.6541 6.52294V11.1813C14.6541 11.6396 15.0291 12.0146 15.4875 12.0146C15.9458 12.0146 16.3208 11.6396 16.3208 11.1813V4.51461C16.3208 4.05628 15.9458 3.68128 15.4875 3.68127L8.82079 3.68127C8.36246 3.68127 7.98746 4.05627 7.98746 4.51461C7.98746 4.97294 8.36246 5.34794 8.82079 5.34794L13.4791 5.34794L4.40413 14.4229C4.08746 14.7396 4.08746 15.2729 4.40413 15.5896Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.c0eea88d143ab070af9005d6471be895.svg";
export { ForwardRef as ReactComponent };